<template>
    <div>
        <PreLoader v-if="isLoading"/>
        <SuperAdminSchoolHead style="align-items: flex-start" class="sas-head">
            <template v-slot:title><span class="sas-title" v-html="$t('markTypes')"/></template>
            <template v-slot:right>
                <v-btn color="primary" @click="openGradeReasonModal('create', {})" v-text="$t('add')"/>
            </template>
        </SuperAdminSchoolHead>
        <div class="scl-ad cards-block">
            <v-card class="card-style" v-for="(item) in allGradeReasons" :key="item.id">
                <v-card-text class="modal-title" v-html="item.courseTitle"/>
                <v-card-text class="card-text" v-for="(reason, i) in item.reasons" :key="i">
                    <div class="grade-txt" v-html="reason.title"/>
                    <div class="grade-txt" v-html="reason.titleKG"/>
                    <v-btn icon @click="openGradeReasonModal('update', reason)">
                        <v-icon color="primary">mdi mdi-pencil-outline</v-icon>
                    </v-btn>
                </v-card-text>
            </v-card>
        </div>
        <v-dialog v-model="gradeDialog">
            <v-card class="pad-20">
                <v-form ref="reasonForm">
                    <h4 v-html="mode === 'create' ? $t('addMarkType') : $t('edit')"/>
                    <v-autocomplete dense outlined :items="adminCourses" item-text="title" item-value="id"
                                    :label="$t('course')" :rules="required" v-model="gradeReasonObj.adminCourseId"/>
                    <v-text-field dense outlined v-model="gradeReasonObj.title"
                                  :label="$t('russian')" :rules="required"/>
                    <v-text-field dense outlined v-model="gradeReasonObj.titleKG"
                                  :label="$t('kyrgyz')" :rules="required"/>
                    <div class="btn-actions">
                        <v-btn color="primary" @click="hideReasonModal" v-text="$t('cancel')"/>
                        <v-btn color="green" @click="submitGradeReason" v-text="$t('save')"/>
                    </div>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { AdminCourseService } from '@/_services/admin-course.service'
import AdminGradeReasonService from '@/_services/admin-grade-reason.service'
import PreLoader from '@/components/preloader/PreLoader'
import SuperAdminSchoolHead from "@/components/super-admin/schools/SuperAdminSchoolHead.vue";
const adminCourseService = new AdminCourseService()

export default {
    components: {SuperAdminSchoolHead, PreLoader},
    data () {
        return {
            required: [v => !!v || this.$t('required')],
            gradeReasonObj: {
                adminCourseId: 0,
                title: '',
                titleKG: '',
                classLevel: ''
            },
            isLoading: false,
            gradeDialog: false,
            mode: '',
            adminCourses: [],
            allGradeReasons: []
        }
    },
    created () {
        this.fetchAdminCourses()
        this.fetchAllAdminGradeReasons()
    },

    methods: {
        fetchAllAdminGradeReasons () {
            this.allGradeReasons = []
            this.isLoading = true
            AdminGradeReasonService.getAll().then((res) => {
                Object.entries(res.reduce((obj, el) => {
                    obj[el['adminCourse'].id] = [...obj[el['adminCourse'].id] || [], el]
                    return obj
                }, {}))
                    .forEach((item, i) => {
                        const reasonObj = { id: i + 1, courseTitle: item[1][0]['adminCourse'].title, reasons: [] }
                        item[1].forEach((reason) => {
                            reasonObj.reasons.push(reason)
                        })
                        this.allGradeReasons.push(reasonObj)
                    })
                this.isLoading = false
            }).catch((err) => {
                this.$toast.error(err)
                this.isLoading = false
            })
        },
        fetchAdminCourses () {
            adminCourseService.list('', 0, 10).then((res) => {
                adminCourseService.list('', 0, res.totalElements).then(result => {
                    this.adminCourses = result.content
                })
            })
        },
        openGradeReasonModal (mode, reasonObj) {
            this.mode = mode
            if (mode === 'create') {
                this.gradeReasonObj.title = ''
                this.gradeReasonObj.titleKG = ''
                this.gradeReasonObj.classLevel = ''
                this.gradeReasonObj.adminCourseId = ''
            } else {
                this.gradeReasonObj.title = reasonObj.title
                this.gradeReasonObj.titleKG = reasonObj.titleKG
                this.gradeReasonObj.classLevel = reasonObj.classLevel
                this.gradeReasonObj.adminCourseId = reasonObj['adminCourse'].id
                this.gradeReasonObj.id = reasonObj.id
            }
            this.gradeDialog = true
        },
        hideReasonModal () {
            this.gradeDialog = false
        },
        submitGradeReason () {
            if (this.$refs.reasonForm.validate()) {
                this.isLoading = true
                AdminGradeReasonService[this.mode](this.gradeReasonObj).then(() => {
                    this.$toast.success(this.mode === 'create' ? 'Успешно создано!' : 'Успешно обновлено!')
                    this.hideReasonModal()
                    this.fetchAllAdminGradeReasons()
                }).catch((err) => {
                    this.$toast.error(err)
                    this.isLoading = false
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.cards-block{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
}
.card-style{
    width: 24.3%;
    min-width: 300px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.modal-title {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
}
.card-text{
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    width: 100%;
}
.grade-txt{
    width: 45%;
    display: flex;
    justify-content: center;
}
</style>
